var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',[(_vm.isLegacyMode)?_c('PdfViewerLegacy',_vm._g({attrs:{"pdfSrc":_vm.src}},_vm.$listeners)):_c('Row',{staticClass:"flex-centerize mr-16"},[_c('DocumentsViewer',_vm._g({attrs:{"documents":_vm.src}},_vm.$listeners))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }